/**
 * Rating formatting for the standings.
 *
 * The rating is an ELO score and can carry decimals (config/ranking.php on the server): a whole
 * value is shown as it is, the others with one decimal, so a table of round numbers does not fill
 * up with ".0". A missing value (a player without a rating yet) reads as a dash.
 */
export function formatRating(value)
{
  if (value === null || value === undefined) {
    return '–'
  }

  const rating = Number(value)

  return Number.isInteger(rating) ? String(rating) : Math.round(rating)
}

/** Rating change of a race, always signed: "+21.3", "-12.5", or "0" when nothing moved. */
export function formatDelta(value)
{
  if (value === null || value === undefined) {
    return '–'
  }

  const delta = Number(value)

  return delta > 0 ? `+${formatRating(delta)}` : formatRating(delta)
}

/**
 * Colour of a rating change: green up, `down` when negative (deep orange by default), neutral when
 * it did not move.
 */
export function deltaColor(value, { down = 'deep-orange' } = {})
{
  if (value === null || value === undefined || value === 0) {
    return 'grey'
  }

  return value > 0 ? 'green-darken-1' : down
}

/** Arrow of a rating change: up, down, or a flat line when it did not move. */
export function deltaIcon(value)
{
  if (value === null || value === undefined || value === 0) {
    return 'mdi-trending-neutral'
  }

  return value > 0 ? 'mdi-trending-up' : 'mdi-trending-down'
}
